import React from "react";
import PropTypes from "prop-types";

import UserPercentage from "shared/components/UserPercentage";
import LikeIcon from "shared/components/svgs/likes_filled.svg";
import PassIcon from "shared/components/svgs/pass.svg";

import "./UserMatchInfo.scss";

// Widget that presents match percentage and like/passed info.
const UserMatchInfo = ({ className, percentages, likes }) => (
	<div className={`match-info ${className}`}>
		<UserPercentage
			className="match-info-user-percentage"
			type={UserPercentage.Type.OVAL}
			{...percentages}
		/>
		{!!(likes && likes.you_like) && (
			<div className="match-info-liked">
				<LikeIcon />
			</div>
		)}
		{!!(likes && likes.passed_on) && (
			<div className="match-info-passed">
				<PassIcon />
			</div>
		)}
	</div>
);

UserMatchInfo.propTypes = {
	className: PropTypes.string,
	percentages: PropTypes.object.isRequired,
	likes: PropTypes.shape({
		you_like: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.bool,
		]),
		passed_on: PropTypes.oneOfType([
			PropTypes.number,
			PropTypes.bool,
		]),
	}),
};

UserMatchInfo.defaultProps = {
	className: "",
	likes: null,
};

export default UserMatchInfo;



// WEBPACK FOOTER //
// ./src/shared/components/UserMatchInfo.jsx